'use strict';

var PayPalProductPageModel = require('../models/payPalProductPageModel');
var ErrorHandlingBaseModel = require('../errorhandler/errorHandlingBaseModel');

var payPalButtonDisplayBehavior = require('./payPalButtonDisplayBehavior');

/**
 * Init PayPal button on the Product Page
 * @param {Promise} clientInstancePromise Client Instance Promise
 */
function init(clientInstancePromise) {
    var payPalButtonSelector = '.prices-add-to-cart-actions .js_braintree_paypal_cart_button';
    var $payPalButton = document.querySelector(payPalButtonSelector);
    var payPalConfigurations = JSON.parse($payPalButton.getAttribute('data-braintree-config'));

    var isVaultMode = payPalConfigurations.options.flow !== 'checkout';
    var requestBillingAgreement = Boolean(payPalConfigurations.options.requestBillingAgreement);
    var isFraudToolsEnabled = payPalConfigurations.isFraudToolsEnabled;
    var $csrfToken = document.querySelector('.braintree-cart-paypal-buttons-wrap #csrf_token');
    var $loaderContainer = document.querySelector('.braintreePayPalLoader');

    var ErrorHandling = new ErrorHandlingBaseModel(payPalConfigurations.messages);
    var PayPalProductPage = new PayPalProductPageModel(
        ErrorHandling,
        clientInstancePromise,
        payPalButtonSelector,
        payPalConfigurations,
        isVaultMode,
        requestBillingAgreement,
        isFraudToolsEnabled,
        $csrfToken,
        $loaderContainer
    );

    // Init behavior for hide/show PayPal button
    payPalButtonDisplayBehavior.initProductPage($payPalButton);
    // Generate Fraud Data if enabled
    PayPalProductPage.generateFraudData();
    // Init PayPal button
    PayPalProductPage.initPayment();
}

module.exports = {
    init
};
